<template>
    <div
        id="main-modal"
        class="modal show"
        :class="modal.class"
        tabindex="-1"
        role="dialog"
        aria-labelledby="main-modal"
        @click="$emit('close')"
    >
        <div
            class="modal-lg modal-dialog modal-dialog-scrollable"
            role="document"
        >
            <div class="modal-content">
                <div class="modal-header">
                    <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        @click="$emit('close')"
                    >
                        <span aria-hidden="true"><i class="fa fa-times" /></span>
                    </button>
                    <h4
                        id="main-modal-body"
                        class="modal-title"
                        v-text="modal.header"
                    />
                </div>
                <div class="modal-body">
                    <h4 v-if="modal.bodyHeader">
                        {{ modal.bodyHeader }}
                    </h4>
                    <div
                        v-if="modal.isBodyHtml"
                        v-html="modal.body"
                    />
                    <p v-else-if="modal.body">
                        {{ modal.body }}
                    </p>
                </div>
                <div class="modal-footer" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        modal: {
            type: Object,
            default: () => ({}),
        },
    },
};
</script>

<style>
.modal-dialog {
    overflow-y: initial !important;
}
.modal-body {
    max-height: 50vh;
    overflow-y: auto;
}
.modal-console .modal-body {
    overflow: hidden;
}
.modal-console .modal-body pre {
    max-height: calc(50vh - 40px);
    background: #333;
    color: #f5f5f5;
}
</style>
